import { render, staticRenderFns } from "./RandomSubjects.vue?vue&type=template&id=494c3dac&"
import script from "./RandomSubjects.vue?vue&type=script&lang=js&"
export * from "./RandomSubjects.vue?vue&type=script&lang=js&"
import style0 from "./RandomSubjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports